module.exports = __webpack_public_path__ + "92a55d38ae961cad1cf1a60931a4c46a.MP3";